import { Component, inject, OnInit, signal } from '@angular/core';
import { BaseComponent } from 'src/app/components/_base/base.component';
import { AuthService } from 'src/app/services/auth/auth.service';
import { DashboardComponent } from 'src/app/components/dashboard/dashboard.component';
import { Client, Roles } from 'src/app/types/identity';
import { OnboardingComponent } from 'src/app/components/onboarding/onboarding.component';
import { AdminReportsPageComponent } from 'src/app/pages/admin/reports/reports.component';

@Component({
  templateUrl: './dashboard.component.html',
  standalone: true,
  imports: [AdminReportsPageComponent, DashboardComponent, OnboardingComponent],
})
export class DashboardPageComponent extends BaseComponent implements OnInit {
  readonly authService = inject(AuthService);

  readonly isAdmin = signal(false);
  readonly finishedOnboarding = signal(true);

  ngOnInit() {
    this.sub$ = this.authService.isAdmin$.subscribe((isAdmin) => {
      this.isAdmin.set(isAdmin);
    });

    this.sub$ = this.authService.user$.subscribe((user) => {
      if (user && user.role === Roles.Client) {
        const _user = user as Client;

        this.finishedOnboarding.set(_user.finishedOnboarding);
      }
    });
  }
}
